<div *ngIf="simulatedFlightFacade.simulatedFlightSkeletonsLoading$ | async">Loading...</div>
<div *ngIf="simulatedFlightFacade.simulatedFlightSkeletonsLoaded$ | async">
  <div *ngIf="simulatedFlightFacade.simulatedFlightSkeletons$ | async as simulatedFlightSkeletons">
    <div *ngIf="simulatedFlightSkeletons.length > 0; else noSimulatedFlights">
      <mat-accordion>
        <div
          *ngFor="
            let simulatedFlightSkeleton of simulatedFlightFacade.simulatedFlightSkeletons$ | async
          "
        >
          <mat-expansion-panel
            (opened)="
              simulatedFlightFacade.loadSimulatedFlightAudit(
                simulatedFlightSkeleton.simulatedFlightId
              )
            "
          >
            <mat-expansion-panel-header>
              Simulated Flight
              <span *ngIf="simulatedFlightSkeleton.simID"
                >&nbsp;SIM ID: {{ simulatedFlightSkeleton.simID }}</span
              >
              <span *ngIf="!simulatedFlightSkeleton.simID"
                >&nbsp;ID: {{ simulatedFlightSkeleton.simulatedFlightId }}</span
              >
              <span *ngIf="simulatedFlightSkeleton.isDeleted">&nbsp;(Deleted)</span>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-audit-detail-list
                [loading]="simulatedFlightFacade.simulatedFlightAuditLoading$ | async"
                [loaded]="simulatedFlightFacade.simulatedFlightAuditLoaded$ | async"
                [audits]="simulatedFlightFacade.simulatedFlightAudit$ | async"
                [noAuditsMessage]="'No audit records for this simulated flight'"
                (nextPage)="
                  simulatedFlightFacade.loadNextSimulatedFlightAuditPage(
                    simulatedFlightSkeleton.simulatedFlightId
                  )
                "
              ></sd-portal-audit-detail-list>
              <mat-expansion-panel
                *ngIf="simulatedFlightSkeleton.logbook"
                (opened)="
                  postedFlightFacade.loadLogbookAudit(simulatedFlightSkeleton.logbook.logbookId)
                "
              >
                <mat-expansion-panel-header
                  >Instruments / Landings / Hold</mat-expansion-panel-header
                >
                <ng-template matExpansionPanelContent>
                  <sd-portal-audit-detail-list
                    [loading]="postedFlightFacade.logbookAuditLoading$ | async"
                    [loaded]="postedFlightFacade.logbookAuditLoaded$ | async"
                    [audits]="postedFlightFacade.logbookAudit$ | async"
                    [noAuditsMessage]="'No audit records for this crew member\'s logbook'"
                    (nextPage)="
                      postedFlightFacade.loadNextPageLogbookAudit(
                        simulatedFlightSkeleton.logbook.logbookId
                      )
                    "
                  ></sd-portal-audit-detail-list>
                </ng-template>
              </mat-expansion-panel>

              <mat-expansion-panel
                *ngIf="
                  simulatedFlightSkeleton.logbook &&
                  simulatedFlightSkeleton.logbook.logbookApproaches &&
                  simulatedFlightSkeleton.logbook.logbookApproaches.length > 0
                "
              >
                <mat-expansion-panel-header>Approaches</mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <mat-accordion>
                    <mat-expansion-panel
                      *ngFor="
                        let logbookApproach of simulatedFlightSkeleton.logbook.logbookApproaches
                      "
                      (opened)="
                        postedFlightFacade.loadLogbookApproachAudit(
                          logbookApproach.logbookApproachId
                        )
                      "
                    >
                      <mat-expansion-panel-header>
                        {{
                          postedFlightFacade.getApproachTypeName(logbookApproach.approachTypeId)
                            | async
                        }}
                        <span *ngIf="logbookApproach.isDeleted">&nbsp;(Deleted)</span>
                      </mat-expansion-panel-header>

                      <ng-template matExpansionPanelContent>
                        <sd-portal-audit-detail-list
                          [loading]="postedFlightFacade.logbookApproachAuditLoading$ | async"
                          [loaded]="postedFlightFacade.logbookApproachAuditLoaded$ | async"
                          [audits]="postedFlightFacade.logbookApproachAudit$ | async"
                          [noAuditsMessage]="'No audit records for this approach'"
                          (nextPage)="
                            postedFlightFacade.loadNextPageLogbookApproachAudit(
                              logbookApproach.logbookApproachId
                            )
                          "
                        ></sd-portal-audit-detail-list>
                      </ng-template>
                    </mat-expansion-panel>
                  </mat-accordion>
                </ng-template>
              </mat-expansion-panel>
            </ng-template>
          </mat-expansion-panel>
        </div>
      </mat-accordion>
    </div>

    <ng-template #noSimulatedFlights> No simulated flights to audit </ng-template>
  </div>
</div>
